var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navigation'),_c('v-main',{staticStyle:{"background-color":"rgba(248, 248, 248, 1)"}},[_c('router-view')],1),_c('Feedback')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }